import {useMemo} from "react";

import {useTranslation} from "react-i18next";

export const useViewTabs = () => {
  const {t} = useTranslation();

  const SIMULATIONS_VIEW_TABS = useMemo(
    () => [
      {
        id: 0,
        name: t("page.simulations.tab.call"),
        value: "call",
        link: "call",
      },
      {
        id: 1,
        name: t("page.simulations.tab.product"),
        value: "product",
        link: "product",
      },
      {
        id: 2,
        name: t("page.simulations.tab.videos"),
        value: "videos",
        link: "videos",
      },
    ],
    [t],
  );

  const SESSIONS_VIEW_TABS = useMemo(
    () => [
      {
        id: 0,
        name: t("page.simulations.tab.call"),
        value: "scenario",
      },
      {
        id: 1,
        name: t("page.simulations.tab.product"),
        value: "product",
      },
      {
        id: 2,
        name: t("page.simulations.tab.certification"),
        value: "certification",
      },
    ],
    [t],
  );

  const DASHBOARD_VIEW_TABS = useMemo(
    () => [
      {
        id: 0,
        name: t("page.dashboard.tab.call"),
        value: "call",
        link: "/admin-panel/dashboard/scenario",
      },
      {
        id: 1,
        name: t("page.dashboard.tab.certification"),
        value: "certification",
        link: "/admin-panel/dashboard/certification",
      },
    ],
    [t],
  );

  const SCORES_VIEW_TABS = useMemo(
    () => [
      {
        id: 0,
        name: t("page.dashboard.simulations"),
        value: "simulations",
      },
      {
        id: 1,
        name: t("page.dashboard.average_score"),
        value: "score",
      },
    ],
    [t],
  );

  const CERTIFICATIONS_VIEW_TABS = useMemo(
    () => [
      {
        id: 0,
        name: t("page.certifications.tab.certifications"),
        value: "certifications",
      },
      {
        id: 1,
        name: t("page.certifications.tab.certifications_scenarios"),
        value: "certifications_scenarios",
      },
    ],
    [t],
  );

  return {
    SIMULATIONS_VIEW_TABS,
    SESSIONS_VIEW_TABS,
    DASHBOARD_VIEW_TABS,
    SCORES_VIEW_TABS,
    CERTIFICATIONS_VIEW_TABS,
  };
};
